import { FC } from 'react'

import ListItem from 'components/UI/ListItem'
import { List as MerinioList } from 'ui'
import { t } from 'translations'

/**
 * Component to render and edit the emails of a user
 */
type Props = {
  items: { item: string; subItem: string }[]
  title: string
  action?: string
}

const List: FC<Props> = ({ items, title, action }) => {
  return (
    <div className="col-md mb-2 mb-md-0">
      <h5>{t(title)}</h5>
      <MerinioList className="mb-2">
        {items.length ? items.map((item, index) => <ListItem {...item} key={index} />) : <ListItem />}
        {action ? (
          <MerinioList.Item className="d-flex align-items-center">
            <div>{action}</div>
          </MerinioList.Item>
        ) : null}
      </MerinioList>
    </div>
  )
}

export default List
